module.exports = __webpack_public_path__ + "cbb.svg?15946f0a59254b17db203c633fc4cf5f";


//////////////////
// WEBPACK FOOTER
// ./index_files/images/cbb.svg
// module id = 4
// module chunks = 0